import { UUID } from '../../redux/app/basicModels';
import { Methodology } from '../../redux/methodology/models';
import axios from 'axios';
import CONFIG from '../../settings';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import methodologyClusterActions from '../../redux/methodologyCluster/actions';
import { AppState } from '../../redux/redux.model';
import useTrackingEvents from '../../helpers/useTrackingEvents';
import { LocalizedName } from '../../redux/methodologyCluster/models';
import { getValueLanguage } from '../../redux/language/utils';
import { ClusterEventType } from './clusterModal.models';

const demeterMethodologyUrl = `${CONFIG.apiUrl}:${CONFIG.demeterPort}/api/v1/methodologies`;

const getMethodology = async (methodologyId: UUID) => {
  const response = await axios.get<Methodology>(`${demeterMethodologyUrl}/${methodologyId}?sort_components=true`);
  return response.data;
};

export const useCluster = () => {
  const dispatch = useDispatch();
  const enablerFlag = useSelector((state: AppState) => state.App.systemFlags)?.P40_50021_ENABLE_CHARACTERISTIC_CLUSTERING;
  const methodologyDeepId = useSelector((state: AppState) => state.MethodologyDeep.methodologyDeep)?.id;

  useEffect(() => {
    const fetchClusters = async () => {
      if (!enablerFlag || !methodologyDeepId) return;
      const methodology = await getMethodology(methodologyDeepId);
      const clustersList = handleParseCluster(methodology);
      if (!clustersList) return;
      dispatch(methodologyClusterActions.setMethodologyClusters(clustersList));
    };

    fetchClusters().then();
  }, [dispatch, enablerFlag, methodologyDeepId]);
};

export const handleParseCluster = (methodology?: Methodology) => {
  return methodology?.inspection_layout?.ordered_inspection_groups
    ?.flatMap(group => group?.ordered_categories)
    .flatMap(category => category?.ordered_phenomenons)
    .flatMap(phenomenon => {
      if (!phenomenon?.component_clusters?.length) {
        return [];
      }
      return phenomenon?.component_clusters
        ?.filter(cluster => cluster?.id)
        ?.map(clusterItem => ({
          ...clusterItem,
          phenomenon_id: phenomenon?.component_id,
          phenomenon_unique_id: phenomenon?.id
        }));
    });
};

export const useClusterSegment = () => {
  const methodologyDeep = useSelector((state: AppState) => state.MethodologyDeep.methodologyDeep);
  const { track } = useTrackingEvents();
  const handleClusterTracking = (
    eventType: ClusterEventType,
    eventData: {
      clusterNames: string[];
      numberOfClusters: number;
      numberOfComponents: number;
    }
  ) => {
    track(`Cluster Events - ${eventType}`, {
      numberOfClusters: eventData.numberOfClusters,
      numberOfComponents: eventData.numberOfComponents,
      clusterNames: eventData.clusterNames,
      organizationId: methodologyDeep?.company?.id,
      organizationName: methodologyDeep?.company?.name,
      cropId: methodologyDeep?.crop?.id,
      cropName: getValueLanguage(methodologyDeep?.crop?.name),
      methodologyId: methodologyDeep?.id
    });
  };

  return { handleClusterTracking };
};

export const handleClusterName = (clusterName: LocalizedName) => {
  return Object.values(clusterName.localized_strings)[0];
};
